<template>

         <w-tabs :items="tabs" :no-slider="false" active-class="primary" v-model="activeTab">
            <template #item-content.1>
               <w-card title-class="blue-dark4--bg white" style="font-size: 13px;" :title="'MAKLUMAT TERNAKAN'" >
            <template #title>
               MAKLUMAT TERNAKAN
               <w-flex justify-end class="mt2">
                  <w-button @click="isMinimizedMakTer = !isMinimizedMakTer">
                     <template v-if="isMinimizedMakTer">
                        <w-icon dark tile class="mr2">fal fa-angle-double-down</w-icon>
                     </template>
                     <template v-else>
                        <w-icon dark tile class="mr2">fal fa-angle-double-up</w-icon>
                     </template>
                  </w-button>
               </w-flex>
            </template>
          <div v-show="!isMinimizedMakTer">
          <div class="table-profil-scrol">
            <table class="w-table" color="light" >
             <thead>
               <tr>
                 <th class="w-table__header  text-center" width="1%">BIL</th>
                 <th class="w-table__header  text-center">NO KES PD</th>
                 <th class="w-table__header  text-center">ID TERNAKAN/NAMA</th>
                 <th class="w-table__header  text-center">BAKA</th>
                 <th class="w-table__header  text-center">TARIKH BERANAK TERDAHULU</th>
                 <th class="w-table__header  text-center">TARIKH SUNTIKAN TERDAHULU / NAMA JURUTEKNIK/JURUSUNTIK</th>
                 <th class="w-table__header  text-center">KAEDAH PEMERIKSAAN</th>
                 <th class="w-table__header  text-center">STATUS</th>
                 <th class="w-table__header  text-center">USIA KEBUNTINGAN (HARI)</th>
                 <th class="w-table__header  text-center">TARIKH JANGKA BERANAK</th>
                 <th class="w-table__header  text-center">CETAK</th>
               </tr>
             </thead>
             <tbody>
               <!-- <template v-if="data.ternakan_list.length == 0">
                 <tr class="w-table__row" >
                   <td class="w-table__cell text-center" colspan="5"> Tiada Data.</td>
                 </tr>
               </template> -->
               <template v-for="(dt, ind) in data.ternakan_list">
                 <tr class="w-table__row" >
                   <td class="w-table__cell text-left" >{{ind+1}}</td>
                   <td class="w-table__cell text-left" style="margin:5px;">{{dt.no_kes}}</td>
                   <td class="w-table__cell text-left" style="margin:5px;">{{dt.ternakan_nama}}</td>
                   <td class="w-table__cell text-left" style="margin:5px;">{{dt.baka}}</td>
                   <td class="w-table__cell text-left"> {{dt.tarikh_beranak_terdahulu}} </td>
                   <td class="w-table__cell text-left" style="margin:10px;">
                     {{$zutil.dateformat(dt.tarikh_suntik_terdahulu)}} | {{dt.nama_juruteknik_terdahulu}}
                   </td>
                   <td class="w-table__cell text-left" style="margin:30px;">
                       {{dt.lkpKaedahPemeriksaan_keterangan}}
                   </td>
                   <td class="w-table__cell text-left" style="margin:80px;">
                       <template v-if="dt.bunting==1">BUNTING</template><template v-else>TIDAK BUNTING</template>
                   </td>
                     <td class="w-table__cell text-right" >
                       {{dt.usia_bunting}}
                     </td>
                   <td class="w-table__cell text-center" style="margin:5px;">{{$zutil.dateformat(dt.jankaan_kelahiran)}}</td>
                   <td align="center">
                      <template v-if="data.lkp_status_id == 18">
                         <w-tooltip md top color="white" bg-color="black">
                           <template #activator="{ on }">
                              <w-button class="ma1" v-on="on" bg-color="success" @click="cetak(dt.id)"><div style="width: 4px"></div> 
                                 <w-icon class="mr1" md style="color: white;">fal fa-print</w-icon>
                              </w-button>
                           </template>
                           Cetak
                        </w-tooltip>
                       </template>
                       <template v-else>-</template>
                     </td>
                 </tr>
               </template>
             </tbody>
           </table>
        </div>
     </div>
         </w-card>
               <br>
              <w-card title-class="blue-dark4--bg white" style="font-size: 13px;" :title="'CAJ PERKHIDMATAN'" >
                   <template #title>
                       CAJ PERKHIDMATAN PD
                       <w-flex justify-end class="mt2">
                           <w-button @click="isMinimizedCajPer = !isMinimizedCajPer">
                               <template v-if="isMinimizedCajPer">
                                   <w-icon dark tile class="mr2">fal fa-angle-double-down</w-icon>
                               </template>
                               <template v-else>
                                   <w-icon dark tile class="mr2">fal fa-angle-double-up</w-icon>
                               </template>
                           </w-button>
                       </w-flex>
                   </template>
                   <div v-show="!isMinimizedCajPer">
                       <figure class="table-aims">
                           <figure class="table">
                               <table class="w-table"><tbody><tr><td>
                                   <div class="grow " style="line-height: 35px">
                                       <table >
                                           <tbody>
                                               <tr>
                                                   <td colspan="3"><strong>Tarikh / Perkhidmatan</strong></td>
                                                   <td width="1px">:</td>
                                                   <td colspan="2">{{$zutil.dateformat(data.tarikh_pemeriksaan_format)}}</td>
                                                   <td width="150px">&nbsp;</td>
                                                   <td>&nbsp;</td>
                                                   <td>&nbsp;</td>
                                                   <td>&nbsp;</td>
                                                   <td>&nbsp;</td>
                                                   <td width="150px">
                                                     <w-tooltip md top color="white" bg-color="black">
                                                        <template #activator="{ on }">
                                                            <w-button class="ma1" v-on="on" bg-color="success" @click="cetakCaj(data.id)"><div style="width: 4px"></div> 
                                                                <w-icon class="mr1" md style="color: white;">fal fa-print</w-icon>
                                                            </w-button>
                                                        </template>
                                                            Cetak Caj Perkhidmatan
                                                      </w-tooltip>
                                                    </td>
                                               </tr>
                                               <tr>
                                                   <td width="1px"><b>1.</b></td>
                                                   <td colspan="2"><strong>Konsultasi / Perkhidmatan</strong></td>
                                                   <td>:</td>
                                                   <td colspan="2">
                                                       <w-tag
                                                           class="mr4"
                                                           bg-color="primary"
                                                           round>
                                                           <template v-if="data.konsutasi_pemeriksaan_ya_tidak==1">Berbayar</template><template v-else>Subsidi</template>
                                                       </w-tag>
                                                       RM {{$zutil.formatDecimal(data.konsutasi)}}
                                                   </td>
                                                   <td>&nbsp;</td>
                                                   <td>&nbsp;</td>
                                                   <td>&nbsp;</td>
                                                   <td>&nbsp;</td>
                                                   <td>&nbsp;</td>
                                                   <td>&nbsp;</td>
                                               </tr>
                                               <tr>
                                                   <td width="1px"><b>2.</b></td>
                                                   <td colspan="2"><strong>Caj Pemeriksaan PD</strong></td>
                                                   <td>:</td>
                                                   <td colspan="2">
                                                       <w-tag
                                                           class="mr4"
                                                           bg-color="primary"
                                                           round>
                                                           <template v-if="data.bayar_pemeriksaan_pd==1">Berbayar</template><template v-else>Subsidi</template>
                                                       </w-tag>
                                                       RM {{$zutil.formatDecimal(data.caj_pemeriksaan_pd)}}
                                                   </td>
                                                   <td>&nbsp;</td>
                                                   <td>&nbsp;</td>
                                                   <td>&nbsp;</td>
                                                   <td>&nbsp;</td>
                                                   <td>&nbsp;</td>
                                                   <td>&nbsp;</td>
                                               </tr>
                                               <tr>
                                                   <td width="1px"><b>3.</b></td>
                                                   <td colspan="2"><strong>Caj Perjalanan</strong></td>
                                                   <td>:</td>
                                                   <td colspan="2">
                                                       <w-tag
                                                           class="mr4"
                                                           bg-color="primary"
                                                           round>
                                                           <template v-if="data.bayar_pengangkutan==1">Berbayar</template><template v-else>Subsidi</template>
                                                       </w-tag>
                                                       RM {{$zutil.formatDecimal(data.pengangkutan)}}
                                                   </td>
                                                   <td>&nbsp;</td>
                                                   <td>&nbsp;</td>
                                                   <td>&nbsp;</td>
                                                   <td>&nbsp;</td>
                                                   <td>&nbsp;</td>
                                                   <td>&nbsp;</td>
                                               </tr>
                                               <tr>
                                                   <td width="1px"><b>4.</b></td>
                                                   <td colspan="2"><strong>Caj Lain-Lain (Jika Ada)</strong></td>
                                                   <td>:</td>
                                                   <td colspan="2">
                                                       <w-tag
                                                           class="mr4"
                                                           bg-color="primary"
                                                           round>
                                                           <template v-if="data.bayar_caj_lain==1">Berbayar</template><template v-else>Subsidi</template>
                                                       </w-tag>
                                                       RM {{$zutil.formatDecimal(data.caj_lain_pemeriksaan)}}
                                                   </td>
                                                   <td>&nbsp;</td>
                                                   <td>&nbsp;</td>
                                                   <td>&nbsp;</td>
                                                   <td>&nbsp;</td>
                                                   <td>&nbsp;</td>
                                                   <td>&nbsp;</td>
                                               </tr>
                                               <tr>
                                                   <td>&nbsp;</td>
                                                   <td>&nbsp;</td>
                                                   <td><strong>Nyatakan</strong></td>
                                                   <td>:</td>
                                                   <td colspan="2">
                                                       <template v-if="data.nyatakan_pemeriksaan==null">-</template>
                                                       <template v-else>{{data.nyatakan_pemeriksaan}}</template>
                                                   </td>
                                                   <td>&nbsp;</td>
                                                   <td>&nbsp;</td>
                                                   <td>&nbsp;</td>
                                                   <td>&nbsp;</td>
                                                   <td>&nbsp;</td>
                                                   <td>&nbsp;</td>
                                               </tr>
                                               <tr>
                                                   <td colspan="3"><strong>Jumlah Caj Keseluruhan</strong></td>
                                                   <td>:</td>
                                                   <td colspan="2" align="left">RM {{$zutil.formatDecimal(data.keseluruhan)}}</td>
                                                   <td>&nbsp;</td>
                                                   <td>&nbsp;</td>
                                                   <td>&nbsp;</td>
                                                   <td>&nbsp;</td>
                                                   <td>&nbsp;</td>
                                                   <td>&nbsp;</td>
                                               </tr>
                                               <tr>
                                                   <td colspan="3"><strong>Jumlah Caj Subsidi</strong></td>
                                                   <td>:</td>
                                                   <td colspan="2" align="left">RM {{$zutil.formatDecimal(data.subsidi)}}</td>
                                                   <td>&nbsp;</td>
                                                   <td>&nbsp;</td>
                                                   <td>&nbsp;</td>
                                                   <td>&nbsp;</td>
                                                   <td>&nbsp;</td>
                                                   <td>&nbsp;</td>
                                               </tr>
                                               <tr>
                                                   <td colspan="3"><strong>Jumlah Caj Yang Perlu Dibayar</strong></td>
                                                   <td>:</td>
                                                   <td colspan="2" align="left">RM {{$zutil.formatDecimal(data.perlu_bayar)}}</td>
                                                   <td>&nbsp;</td>
                                                   <td>&nbsp;</td>
                                                   <td>&nbsp;</td>
                                                   <td>&nbsp;</td>
                                                   <td>&nbsp;</td>
                                                   <td>&nbsp;</td>
                                               </tr>
                                           </tbody>
                                       </table>
                                   </div>
                               </td></tr></tbody></table>
                           </figure>
                       </figure>
                   </div>
               </w-card>
               <br>
               <br>
               <w-flex justify-end class="mt2" v-if="data.lkp_status_id==35 && $zutil.anyRole(['2','1','5'])">
                <w-button class="my1" :loading="data.submitted && !data.sent" bg-color="success" type="success" @click="sahkan(18)">
                  <w-icon dark tile class="mr2">fal fa-check-circle</w-icon> SAHKAN
                </w-button>&nbsp;
                <w-button class="my1" :loading="data.submitted && !data.sent" bg-color="error" type="success" @click="semaksemula()">
                  <w-icon dark tile class="mr2">fal fa-times-circle</w-icon> SEMAKAN SEMULA
                </w-button>
            </w-flex>
               <br>
            </template>
            <!-- <template #item-content.2>
               <ButiranKelahiran :d_data="data" :d_segmenName="segmenName" v-if="data.id > 0"/>
            </template> -->
            <template #item-content.3>
               <w-card title-class="blue-dark4--bg white" style="font-size: 13px;"  :title="'AUDIT TRAIL'" >
                  <div class="w-table-wrap" style="max-height: 400px;">
                     <div class="table-profil-scrol">
                        <table class="w-table" color="light" >
                           <thead>
                              <tr>
                                <th class="w-table__header  text-center" width="1%">BIL</th>
                                <th class="w-table__header  text-center">USER</th>
                                <th class="w-table__header  text-center">STATUS</th>
                                <th class="w-table__header  text-center">REMARK</th>
                                <th class="w-table__header  text-center">TARIKH</th>      
                              </tr>
                           </thead>
                           <tbody>
                              <template v-for="(data, ind) in data.audit_trail">
                              <tr class="w-table__row" >
                                  <td class="w-table__cell text-center" >{{ind+1}}</td>
                                  <td class="w-table__cell text-center" >{{data.user}}</td>
                                  <td class="w-table__cell text-center" >{{data.status}}</td>
                                  <td class="w-table__cell text-center" >{{data.remark}}</td>
                                  <td class="w-table__cell text-center" >{{data.tarikh}}</td>
                                 </tr>
                              </template>
                           </tbody>
                        </table>
                     </div>
                  </div>
               </w-card>
            </template>
         </w-tabs>
         <w-dialog
            v-model="dialogSemak.show"
            :fullscreen="dialogSemak.fullscreen"
            :width="dialogSemak.width"
            :persistent="dialogSemak.persistent"
            :persistent-no-animation="dialogSemak.persistentNoAnimation"
            title-class="primary-dark1--bg white">
            <template #title>
               <w-icon class="mr2">fal fa-list</w-icon>
               Semak Semula Perkhidmatan
            </template>
            <br>{{dialogSemak.form}}
            <w-form 
               ref="form" 
               v-model="dialogSemak.valid"
               @validate="sahkan(27)"
               @success="success"
             >
            <div class="w-flex wrap smd-column" >
                <w-textarea style="margin:5px;" label="Catatan *"  placeholder="Sila masukan.." class="mt4" outline  v-model="dialogSemak.item.catatan" :validators="[validators.required]"/>
            </div>
            </w-form>
            <template #actions>
               <div class="spacer" />
               <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialogSemak.show = false">TUTUP</w-button>
               &nbsp;
               <w-button class="mr2" :loading="dialogSemak.loading" :disabled="dialogSemak.loading || dialogSemak.item.catatan == null" @click="sahkan(27)">
                  <w-icon m class="mr2">fal fa-paper-plane</w-icon>Hantar
               </w-button>
            </template>
         </w-dialog>
         
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'
// import Ternakan from './Show/Ternakan.vue';
import VueQrcode from 'vue-qrcode'


export default {
  extends: ZResource,
  components: {
    VueQrcode, 
  },
  props: {
    d_id: [Array, Object, String],

  },
  data() {
    return {
      resourceurl: 'art.permohonan',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Pembiakan Permohonan', route: '/art' },
        { label: 'Permohonan', route: '/art/permohonan' },
        { label: 'Papar', route: '/art/permohonan/'+this.id },
      ],

      title : '',
      id:this.d_id,
      data : {id : 0},
      activeTab : 0,
      activeTabModal : 0,
      ada_bunting: 0,
      ternakan_list:[],
      tabs: [
            { title: 'RUMUSAN PERKHIDMATAN', content: '' },
            { title: 'AUDIT TRAIL', content: '', disabled:true},//disable dulu
      ],
      tabsModal: [
            { title: 'MAKLUMAT PEMERIKSAAN TERNAKAN', content: '' },
            { title: 'MAKLUMAT PROSEDUR ET', content: ''},
            { title: 'MAKLUMAT PEMERIKSAAN BUNTINGAN ET', content: ''},
      ],
      ibvk: [],
      negri: [],
      persendirian: [],
      isMinimizedList: false,
      isMinimizedCajAi: false,
      isMinimizedCajKeb: false,
      dialog: {
          valid: false,
          show: false,
          fullscreen: false,
          persistent: true,
          persistentNoAnimation: false,
          loading: false,
          width: 1500,
          tab: 0,
          item: []
        },
      dialogPd: {
          valid: false,
          show: false,
          fullscreen: false,
          persistent: true,
          persistentNoAnimation: false,
          loading: false,
          width: 900,
          item: []
        },
      dialogSemak: {
         valid: false,
         show: false,
         fullscreen: false,
         persistent: true,
         persistentNoAnimation: false,
         loading: false,
         width: 900,
         item: {
            catatan:null
         }
      },
      juruteknik_list: [],
      lkp_tujuan:[],
      form_pd:{
         art_id: 0,
         lkp_tujuan_id: null,
         juruteknik_pd_id: 0,
         jankaan_biang_semula: null,
         tarikh_datang_pemeriksaan: null,
      },
      jankaan_biang_semula:null,
    }
  },
  methods: {
      semaksemula(){
         this.dialogSemak.show = true;
      },
      validateForm() {
         this.loading=true;
         let isValid = true;
         let jumlah_lulus = 0;
         this.data.ternakan_list.forEach((row) => {
            if (row.pilih == true) {
               jumlah_lulus = 1;
            }
         })

         if (jumlah_lulus == 0) {
           this.$zutil.notify("Pastikan data sudah di Pilih", false);
           this.loading=false;
           return false;
         }

         this.MohonSemula()
      },

      MohonSemula(){
         this.$swal({
             title: 'Anda Pasti?',
             // text: "Are you sure want to delete this item!",
             type: 'warning',
             showCancelButton: true,
             confirmButtonColor: '#3085d6',
             cancelButtonColor: '#d33',
             confirmButtonText: 'Ya',
             cancelButtonText: 'Tidak'
            }).then((result) => {
            if (result.value) {
               if(this.data.id > 0){
               this.$zcomm.update('art.semakan.mohonSemulaAi', this.data.id, this.data)
                 .then(res => {
                     this.$inertia.visit(window.route('art.permohonan.form',0)+'?salin='+this.data.id);
                     this.loading = false;
                 })
                 .catch(err => {

                 })
                 .finally(() => {
                   
                 });
             }
           }else{ this.loading = false;}

           }) 
      },
      mohonPd(dt, tab){
         this.form_pd.art_id = this.data.id;
         this.form_pd.lkp_tujuan_id = 5;
         this.form_pd.jankaan_biang_semula = this.jankaan_biang_semula ;
         this.form_pd.tarikh_datang_pemeriksaan = null; 
         this.dialogPd.show = true;
         this.getJuruteknik();
         this.getTujuanPd();
      },
      getJuruteknik(data){
         this.$zcomm.get(this.api_service + 'lookup/juruteknik/'+this.data.lkp_negeri_id+'/2'+'/0', {}).then(res => {
            this.juruteknik_list = res
         });
      },
      getTujuanPd(){
         this.$zcomm.get(this.api_service + 'lookup/tujuan_pd', {}).then(res => {
           this.lkp_tujuan = res
         })
      },
      hantarMohon(){
         let isValid = true;
         this.loading=true;
         if (!this.form_pd.juruteknik_pd_id || !this.form_pd.tarikh_datang_pemeriksaan) {
           isValid = false;
           this.loading=false;
         }
         if (!isValid) 
         {
           this.$zutil.notify("Pastikan semua data sudah diisi", false);
           this.loading=false;
           return false;
         }
         this.$swal({
             title: 'Anda Pasti?',
             // text: "Are you sure want to delete this item!",
             type: 'warning',
             showCancelButton: true,
             confirmButtonColor: '#3085d6',
             cancelButtonColor: '#d33',
             confirmButtonText: 'Ya',
             cancelButtonText: 'Tidak'
            }).then((result) => {
            if (result.value) {
               if(this.data.id > 0){
               this.$zcomm.update('art.semakan.mohonpd', this.data.id, this.form_pd)
                 .then(res => {
                     this.loading = false;
                     this.dialogPd.show = false;
                     this.$inertia.reload();
                     this.$inertia.visit(window.route('art.permohonan'));
                 })
                 .catch(err => {

                 })
                 .finally(() => {
                   
                 });
                 this.dialogPd.loading = false;
             }
           }else{ this.loading = false;}

           }) 
      },
      detail(datas, tab){
         this.dialog.item = datas;
         this.dialog.tab = tab ? tab : 0;
         this.dialog.show = true;
      },
    tutup(){
         this.$inertia.visit(window.route('art.permohonan'));
       },

    cetak(data){
        // this.$inertia.visit(route("kursus.kursus.peserta.sijil_peserta", dt.peseta_user_id) +"?kursus_id="+dt.id,);
        window.open( window.route('art.permohonan.cetak', data), '_blank');
    },


    cetakCaj(data){
        window.open( window.route('art.cetak_caj', data+'?lkp_art='+2), '_blank');

    },

    sahkan(item) {
         if (item == 27) {
            let isValid = true;
            this.dialogSemak.loading=true;
            if (!this.dialogSemak.item.catatan) {
              isValid = false;
              this.dialogSemak.loading=false;
            }
            if (!isValid) 
            {
              this.$zutil.notify("Catatan Wajib diisi", false);
              this.dialogSemak.loading=false;
              return false;
            }
            this.data.semakan_catatan = this.dialogSemak.item.catatan;
         }
        this.loading = true;
        this.$swal({
          title: 'Anda Pasti?',
          // text: "Are you sure want to delete this item!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak'
        }).then((result) => {
        if (result.value) {
          if(this.data.id > 0){
            this.data.lkp_status_id = item;
            this.data.peternak = 1;
          this.$zcomm.update('art.semakan.pd-aiman.update', this.data.id, this.data)
              .then(res => {
                  this.dialog.show = false;
                  this.$inertia.visit(window.route('art.semakan.index'));
              })
              .catch(err => {

              })
              .finally(() => {
              });
              this.dialog.loading = false;
          }
        }else{ this.loading = false;
               this.dialogSemak.loading=false;
            }

        }) 
      },
      // kiraanProsedurAi(){
      //       for (var b in this.data.ternakan_list){
      //          if (this.data.ternakan_list[b].se_stock_id!=null) {
      //             this.jankaan_biang_semula = this.data.ternakan_list[b].jankaan_biang_semula;
      //             break;
      //          }
      //       }
      //       var total_harga = 0;

      //       let ibvk = [];
      //       ibvk = this.data.ternakan_list
      //          .filter((item) => item.lkp_kategori_semen_id === 1)
      //          .map((item) => ({
      //            no_batch_keterangan: item.no_batch_keterangan,
      //            kuantiti: item.bil_straw,
      //            harga: parseFloat(item.harga_straw),
      //            total_harga: parseFloat(item.harga_straw) * item.bil_straw,
      //       }));

      //       let negri = [];
      //       negri = this.data.ternakan_list
      //          .filter((item) => item.lkp_kategori_semen_id === 2)
      //          .map((item) => ({
      //            no_batch_keterangan: item.no_batch_keterangan,
      //            kuantiti: item.bil_straw,
      //            harga: parseFloat(item.harga_straw),
      //            total_harga: parseFloat(item.harga_straw) * item.bil_straw,
      //       }));

      //       let persendirian = [];
      //       persendirian = this.data.ternakan_list
      //          .filter((item) => item.lkp_kategori_semen_id === 3)
      //          .map((item) => ({
      //             no_batch_keterangan: item.id_ternakan+' | '+item.no_batch,
      //            kuantiti: item.bil_straw,
      //            harga: parseFloat(item.harga_straw),
      //            total_harga: parseFloat(item.harga_straw) * item.bil_straw,
      //       }));

      //       const totalIbvk = ibvk.reduce((accumulator, item) => accumulator + item.total_harga, 0);
      //       const totalNegri = negri.reduce((accumulator, item) => accumulator + item.total_harga, 0);
      //       const totalPersendirian = persendirian.reduce((accumulator, item) => accumulator + item.total_harga, 0);

      //     // Output
      //     console.log('No Batch List:', ibvk);
      //       var no_batch_keterangan = [];
      //       for (var b in this.ternakan_list){
      //         if (this.ternakan_list[b].lkp_kategori_semen_id==1) {
      //           no_batch_keterangan= this.ternakan_list[b].no_batch_keterangan
      //         }
      //       }
      //       this.ibvk = ibvk;
      //       this.negri = negri;
      //       this.persendirian = persendirian;
      //       this.data.keseluruhan = Number(this.data.pengangkutan) + Number(this.data.konsutasi) + Number(this.data.caj_lain) + Number(totalIbvk) + Number(totalNegri) + Number(totalPersendirian);
      //       if(this.data.jenis_pengguna_pemohon == 1){
      //          if(this.data.konsutasi_ya_tidak==2){ 
      //             var subsidi = Number(totalIbvk) + Number(totalNegri) + Number(this.data.pengangkutan) + Number(this.data.konsutasi) + Number(this.data.caj_lain);
      //          }else{
      //             var subsidi = Number(totalIbvk) + Number(totalNegri) + Number(this.data.pengangkutan) + Number(this.data.caj_lain);
      //          }
      //          this.data.subsidi = subsidi;
      //          this.data.perlu_bayar = this.data.keseluruhan - subsidi;
      //       }else{
      //          if(this.data.konsutasi_ya_tidak==2){ 
      //             var subsidi = Number(totalIbvk) + Number(this.data.konsutasi) + Number(totalNegri);
      //             // var perlu_bayar = Number(totalPersendirian) + Number(this.datas.caj_lain)+ Number(this.datas.pengangkutan);
      //          }else{
      //             var subsidi = Number(totalIbvk) + Number(totalNegri);
      //             // var perlu_bayar = Number(this.datas.konsutasi) + Number(totalPersendirian) + Number(this.datas.caj_lain)+ Number(this.datas.pengangkutan);
      //          }
      //          this.data.subsidi = subsidi;
      //          this.data.perlu_bayar = this.data.keseluruhan - subsidi ;
      //       }
      //    // console.log(datas.perlu_bayar)
      //  },

      kiraanProsedurAi() {

           for (let b in this.data.ternakan_list) {
             if (this.data.ternakan_list[b].se_stock_id != null) {
               this.jankaan_biang_semula = this.data.ternakan_list[b].jankaan_biang_semula;
               break;
             }
           }


           const ibvk = this.data.ternakan_list
             .filter(item => item.lkp_kategori_semen_id === 1)
             .map(item => ({
               no_batch_keterangan: item.no_batch_keterangan,
               kuantiti: item.bil_straw,
               harga: Number(item.harga_straw) || 0,
               total_harga: (Number(item.harga_straw) || 0) * item.bil_straw,
             }));

           const negri = this.data.ternakan_list
             .filter(item => item.lkp_kategori_semen_id === 2)
             .map(item => ({
               no_batch_keterangan: item.no_batch_keterangan,
               kuantiti: item.bil_straw,
               harga: Number(item.harga_straw) || 0,
               total_harga: (Number(item.harga_straw) || 0) * item.bil_straw,
             }));

           const persendirian = this.data.ternakan_list
             .filter(item => item.lkp_kategori_semen_id === 3)
             .map(item => ({
               no_batch_keterangan: item.id_ternakan + ' | ' + item.no_batch,
               kuantiti: item.bil_straw,
               harga: Number(item.harga_straw) || 0,
               total_harga: (Number(item.harga_straw) || 0) * item.bil_straw,
             }));

           const totalIbvk = ibvk.reduce((sum, item) => sum + item.total_harga, 0);
           const totalNegri = negri.reduce((sum, item) => sum + item.total_harga, 0);
           const totalPersendirian = persendirian.reduce((sum, item) => sum + item.total_harga, 0);


           const no_batch_ibvk = ibvk.map(item => item.no_batch_keterangan);


           this.ibvk = ibvk;
           this.negri = negri;
           this.persendirian = persendirian;

          
           const pengangkutan = Number(this.data.pengangkutan) || 0;
           const konsutasi = Number(this.data.konsutasi) || 0;
           const caj_lain = Number(this.data.caj_lain) || 0;

           // const keseluruhan = pengangkutan + konsutasi + caj_lain + totalIbvk + totalNegri + totalPersendirian;
           this.data.keseluruhan = keseluruhan;

           
           let subsidi = 0;
           let perlu_bayar = 0;

           
           subsidi += totalIbvk + totalNegri;

           if (this.data.jenis_pengguna_pemohon == 1) {
             
             if (this.data.konsutasi_ya_tidak == 2) subsidi += konsutasi;
             subsidi += pengangkutan + caj_lain;
           } else {
             
             if (this.data.konsutasi_ya_tidak == 2) subsidi += konsutasi;
           }

           perlu_bayar = keseluruhan - subsidi;

           this.data.subsidi = subsidi;
           this.data.perlu_bayar = perlu_bayar;
         },

      cetak(data){
        // this.$inertia.visit(route("kursus.kursus.peserta.sijil_peserta", dt.peseta_user_id) +"?kursus_id="+dt.id,);
        window.open( window.route('art.cetak_ternakan.cetak', data), '_blank');
    },

      cekKebuntingan(){
         this.ada_bunting = 0;
         for (var b in this.data.ternakan_list) {
               if(this.data.ternakan_list[b].bunting == 1 || this.data.ternakan_list[b].bunting_art == 1){
                  this.ada_bunting = 1;
                  break;
               }else{
                  this.ada_bunting = 0;
              }
         }
      },
  
    getData()
    {
      this.$zcomm.get(this.api_service + 'art/show/'+this.id, {}).then(res => {
        this.data = res

         this.kiraanProsedurAi();
         this.cekKebuntingan();
        // if (this.data) {}
      // if(this.$zutil.role('1')){
      //     this.tabs = [
      //       // { title: 'Baka', content: '' },
      //       { title: 'Ternakan', content: '' },
            
      //     ]
      //   }
      //   else
      //   {
      //     this.tabs = [
      //       { title: 'Ternakan', content: '' },
           
      //     ]
      //   }
         // if(this.data.lkp_status_id==40||this.data.lkp_status_id==18){
         //    this.tabs[1].disabled = false;
         // }else{
         //    this.tabs[1].disabled = true;
         // }
       if(this.data.lkp_art_id == 1)
        {
          this.title = 'RUMUSAN PERKHIDMATAN AI'
        }
        if(this.data.lkp_art_id == 2)
        {
          this.title = 'RUMUSAN PEMERIKSAAN KEBUNTINGAN PD'
        }
        if(this.data.lkp_art_id == 3)
        {
          this.title = 'RUMUSAN PERKHIDMATAN ET'
        }
        this.params = location.search.slice(1).split('&').map(p => p.split('=')).reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
      if(this.params.t == 2){
        this.activeTab = 1
      }

      })
    },

    
   

  },
  watch: {

  },
  mounted() {
    this.getData();

    
    
  },
}
</script>

<style>
.table-aims td{
   padding: 7px;
}
</style>

